import React from 'react';
import moment from 'moment-timezone';
import groupBy from 'lodash.groupby';
import orderBy from 'lodash.orderby';
import { TitleStyles } from './styles';
import { Search } from '../types';

function GetDateInCurrentTimeZone(date: any) {
  const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcDate = moment.tz(date, 'Universal');
  return moment(utcDate).tz(browserTZ);
}
interface Props {
  searches: Search[];
}
const OrderCompleted = (props: Props) => {
  const groupByStatusType = () => {
    const sortedSearches = orderBy(
      props.searches, 
      [(a) => new Date(a.dateAdded).valueOf()],
      ['desc']
    )
    return groupBy(
     sortedSearches,
      'searchStatusType'
    );
  };
  const grouped = groupByStatusType();
  const allCompleted = Object.keys(grouped).length === 1 && grouped.Completed;
  return (
    <div>
      {allCompleted && (
        <>
          <div style={{ marginTop: 38 }}>
            <TitleStyles style={{ width: 200 }}>Order Completed On</TitleStyles>
            <div style={{ marginTop: 12 }}>
              {' '}
              {GetDateInCurrentTimeZone(grouped.Completed[0].dateAdded).format('MM/DD/YYYY')}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderCompleted;
